import { Dispatch } from 'redux'
import { ReportGeneratorService } from '../../../services/reportGenerator.service';

export const generateRiskScoreGenAI: any = (riskScore: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'GENERATE_RISK_SCORE_LOADING' });
        const res = await ReportGeneratorService.riskScoreGenAI(riskScore);
        if(!res) {
            throw new Error('Error generating risk score');
        }
        dispatch({ type: 'GENERATE_RISK_SCORE_SUCCESS', payload: res.value });
    } catch(e) {
        dispatch({ type: 'GENERATE_RISK_SCORE_ERROR' });
    }
}

export const calculateRiskScore: any = (riskScore: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'CALCULATE_RISK_SCORE_LOADING' });
        const res = await ReportGeneratorService.calculateRiskScore(riskScore);
        if(!res) {
            throw new Error('Error generating risk score');
        }
        dispatch({ type: 'CALCULATE_RISK_SCORE_SUCCESS', payload: res.value });
    } catch(e) {
        dispatch({ type: 'CALCULATE_RISK_SCORE_ERROR' });
    }
}